import React from 'react';
import { Divider, Typography } from '@mui/material';
import badhakopi from '../../../../../images/Agri-info/crops/Cabbages_বাঁধা কপি.jpg';
import useDocumentTitle from '../../../../../hooks/useDocumentTitle';

const BadhakopiInfo = () => {

    // dynamic title
    useDocumentTitle("বাঁধা কপি");

    return (

        <div className=" rounded-3 bg-white my-4 px-5">
            <Typography
                sx={{
                    textAlign: "center",
                    pb: 2,
                    pt: 3,
                    fontWeight: 600,
                    color: 'rgb(37, 36, 36, 0.83)'
                }}
                variant="h3"
                noWrap
                component="div"
            >
                বাঁধা কপি
            </Typography>
            <Divider />

            <div className="card mt-4 mb-3 border-0 rounded-0">
                <div className="row g-0">
                    <div className="col-md-4">
                        <img src={badhakopi} className="img-fluid rounded-0 h-100" alt="..." />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body text-start ">
                            <p>রবি মৌসুমের একটি প্রধান সবজি। দেশের প্রায় সব অঞ্চলেই বাঁধাকপির চাষ হয়। বাঁধাকপি একটি অত্যন্ত পুষ্টিকর সবজি। এদেশে উৎপাদিত বাঁধাকপির প্রায় সব জাতই বিদেশী ও হাইব্রিড। সব জাতের বীজ এদেশে উৎপাদন করা যায়না। তবে এদেশে বীজ উৎপাদন করা যায় বারি উদ্ভাবিত এমন জাতও আছে।</p>

                            <p className="card-text fw-bold">পুষ্টি মূল্য</p>
                            <p className="card-text">বাঁধাকপি একটি অন্যতম পুষ্টিকর পাতা জাতীয় সবজি। এত প্রচুর পরিমাণে ভিটামিন ‘এ‘ রয়েছে। ডায়াবেটিস রোগীদের জন্য এটি বেশ উপকারী।</p>

                        </div>
                    </div>
                </div>
            </div>

            <div className='text-start pb-5'>

                <p className="card-text fw-bold">মাটি</p>
                <p className="card-text">অত্যধিক বেলে মাটি ছাড়া যে কোন ধরনের মাটিতে এটি জন্মে। বেলে দোঁআশ থেকে পলি দোঁআশ মাটি এ ফসলের জন্য উপযোগী।</p>

                <p className="card-text fw-bold">জাত</p>
                <p className="card-text">আগাম জাত লাগাতে চাইলে লাগাতে হবে কে কে ক্রস এবং এক্সপ্রেস ক্রস জাত দুটি। মধ্যম সময়ের উপযোগী জাত হল কে ওয়াই ক্রয়, এটলাস ৭০, টোকিও প্রাইড, গ্রীন এক্সপ্রেস, প্রভাতী ইত্যাদি। আর দেরীতে লাগাতে চাইলে লাগাতে হবে এটলাস ৭০, লিও ৮০, সেভয়, রুবি বল, ড্রাম হেড ইত্যাদি। এ দেশের আবহাওয়ায় বীজ উৎপাদন করতে চইলে করতে হবে বারি বাঁধাকপি ২ (অগ্রদূত), ইপসা বাঁধাকপি ১। সমপ্রতিক আমদানীকৃত হাইব্রিড জাতসমূহের মধ্যে উল্লেখযোগ্য হল সামার ওয়ারিয়র এফ ১, লরেন্স এফ ১, গ্রীন ৬২১ এফ ১, সামার ষ্টার এফ ১, গ্রীন কর্নেট এফ ১, অটাম কুইন এফ ১, সুপার ট্রপিক এফ ১, সামার বয় এফ ১, গ্রীন বল ৪০ এফ ১, সুপ্রিম কুইন এফ ১ ইত্যাদি।</p>

                <p className="card-text fw-bold">লাগানোর সময়</p>
                <p className="card-text">বাঁধাকপি শীতকালেই ভাল হয়। শীত মৌসুমে আগাম ও নাবী করেও চাষ করা যায়। তবে সমপ্রতি গ্রীষ্ম ও বর্ষকালেও বাঁধাকপি উৎপাদিত হচ্ছে।</p>

                <p className="card-text fw-bold">বীজের পরিমাণ</p>
                <p className="card-text">জাত ভেদে প্রতি শতকে ২-৩ গ্রাম, হেক্টর প্রতি ৫০০-৭০০ গ্রাম।</p>

                <p className="card-text fw-bold">চারা উৎপাদন পদ্ধতি</p>
                <p className="card-text">বাঁধা কপির চারা বীজতলায় উৎপাদন করে জমিতে লাগানো হয়। বীজতলার আকার ১ মিটার পাশে ও লম্বায় ৩ মিটার হওয়া উচিত। সমপরিমাণ বালি, মাটি ও জৈবসার মিশিয়ে ঝুরাঝুরা করে বীজতলা তৈরি করতে হয়। দ্বিতীয় বীজতলায় চারা রোপণের আগে ৭/৮ দিন পূর্বে প্রতি বীজতলায় ১০০ গ্রাম ইউরিয়া, ১৫০ গ্রাম টিএসপি ও ১০০ গ্রাম এমওপি সার ভালভাবে মিশিয়ে দিতে হবে। পরে চারা ঠিকমত না বাড়লে প্রতি বীজতলায় প্রায় ১০০ গ্রাম পরিমাণ ইউরিয়া সার ছিটিয়ে দেয়া ভাল।</p>

                <p className="card-text fw-bold">জমি তৈরি ও চারা রোপণ</p>
                <p className="card-text">গভীর ভাবে ৪-৫টি চাষ দিয়ে মাটি ঝুরঝুরে করে তৈরি করতে হবে। বীজ বপনের ৩০-৩৫ দিন পর বা ৫/৬টি পাতা বিশিষ্ট ১০-১৫ সেন্টিমিটার লম্বা  চারা সাধারণতঃ বিকেল বেলা জমিতে রোপণ করতে হয়। তবে সুস' ও সবল হলে চারা এক-দেড় মাস বয়সের চারা রোপণ করা যায়। রোপণের জন্য সারি থেকে সারির দুরত্ব ৬০ সেন্টিমিটার  এবং প্রতি সারিতে চারা থেকে চারার দূরত্ব ৪৫ সেন্টিমিটার দিলে ভাল হয়। এ হিসেবে প্রতি শতকে ১৫০টির মত চারার প্রয়োজন হয়। আঙ্গিনায় ৫ মিটার লম্বা একটা বেডের জন্য ২০-২২টি চারার প্রয়োজন হয়। বেডে দুই সারিতে চারাগুলো লাগাতে হবে। আঙ্গিনায় লাগানোর জন্য যেহেতু কম চারার দরকার হয় সেজন্য কোন বিশ্বস- নার্সারি থেকে চারা কিনে লাগানো ভাল। তবে একটা বেডে বাঁধাকপির চারা তৈরি করে অল্পদিনের মধ্যেই তা বিক্রি করে যেমন অধিক লাভবান হওয়া যায় তেমনি নিজের প্রয়োজনও মেটানো যায়। এত ভাল চারা পাওয়াটা নিশ্চিত হয়।</p>

                <p className="card-text fw-bold">সার প্রয়োগ ও সেচ দেয়া</p>
                <p className="card-text">প্রতি শতকে গোবর ১২৫ কেজি, ইউরিয়া ১ কেজি, টিএসপি ৮০০ গ্রাম, এমওপি ৬৫০ গ্রাম সার দিতে হবে। সম্পূর্র্ণ গোবর ও টিএসপি সার জমি তৈরির সময় প্রয়োগ করতে হবে। ইউরিয়া  ও এমওপি সার ২ কিসি-তে চারা রোপণের ২০-২৫ দিন পর একবার এবং ৩০-৪০ দিন পর আর একবার উপরি প্রয়োগ করতে হবে। সার দেয়ার পর পরই সেচ দিতে হবে। এ ছাড়া ২-৩ দিন পর পরই সেচ দিতে হবে। গাছ বড় হবার সাথে সাথে দুই সারির মাঝখান থেকে মাটি তুলে সারি বরাবর আইলের মত করে দিতে হবে। ফলে  দু’সারির মাঝে নালা তৈরি হবে। এতে সেচ দিতে বেশ সুবিধে হবে।</p>

                <p className="card-text fw-bold">পোকা মাকড় ব্যবস্থাপনা</p>
                <p className="card-text">এদেশে বাঁধাকপির সবচে ক্ষতিকর পোকা হল মাথা খেকো লেদা পোকা। নাবী করে লাগালে সরুই পোকা বা ডায়মন্ড ব্যাক মথ বেশি ক্ষতি করে। বীজ উৎপাদনের জন্য চাষ করলে পুষ্পমঞ্জরীকে জাব পোকার হাত থেকে রক্ষা করতে হবে। অন্যান্য পোকার মধ্যে ক্রসোডলমিয়া লেদা পোকা, বিছা পোকা, ঘোড়া পোকা ইত্যাদি মাঝে মাঝে ক্ষতি করে থাকে।</p>

                <p className="card-text fw-bold">রোগ ব্যবস্থাপনা</p>
                <p className="card-text">বাঁধাকপির পাতায় দাগ ও কালো পচা রোগ প্রধান সমস্যা। এছাড়া চারা ধ্বসা বা ড্যাম্পিং অফ, মাথা পচা বা গ্রে মোল্ড, ক্লাব রুট বা গদাই মূল, মোজেইক, পাতার আগা পোড়া ইত্যাদি রোগও হয়ে থাকে।</p>

                <p className="card-text fw-bold">ফসল সংগ্রহ ও ফলন</p>
                <p className="card-text">চারা রোপণের ৬০-৯০ দিন পর বাঁধাকপি সংগ্রহ করা যায়। প্রতিটি বাঁধাকপি গড়ে ২.৫ কেজি হয়। ফলন এক শতকে ১৫০-১৮০ কেজি, হেক্টরে ৭৫-৮০ টন, প্রভাতী জাতের ফলন ১১০-১১০ টন/হেক্টর।</p>

            </div>
        </div >

    );
};

export default BadhakopiInfo;